var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplosive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.089 .001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#ffce6e",
    transform: "translate(-.089 -.001)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ff462e",
    d: "M27.11 76.073l1.73-1.791 1.129 2.309s-1.474 6.295-3.407 6.577-5.438-2.818-5.438-2.818l.82-1.581.786-1.517 1.516-.217.772-1.645 2.015-.325zM19.554 61.6a6.442 6.442 0 0 1-3.56 2.706v3.7s.134.794 3.206.085c-.791-.544 1.775-8.561.354-6.491zm0 6.41l-.354.085c.079.052.2.031.354-.089zm13.458-8.458l-2.45-2.584a8.985 8.985 0 0 1-3.121 2.958 7.09 7.09 0 0 1 3.767 1.335zm-6.725-8.795l-.65-.687a2.385 2.385 0 0 1-.829.786 1.886 1.886 0 0 1 1 .354zM12.886 53.9l-.65-.686a2.384 2.384 0 0 1-.829.786 1.883 1.883 0 0 1 1 .354zm14.72 21.033a.561.561 0 0 1-.011-.317.723.723 0 0 1-.3.166l.137.247zM26.54 73.84l.253.456.319-.178a1.044 1.044 0 0 1-.021-.585 1.312 1.312 0 0 1-.551.307zm-4.832 1.56a1.874 1.874 0 0 1 1 .354l.479-.454-.651-.686a2.4 2.4 0 0 1-.828.786zm9.128-2.744a1.418 1.418 0 0 1-.524.416l3.333-13.192L31.2 62.2l-.482-.382c-.006-.005-.065-.05-.168-.118l-1.833 11.918.123.664 1.335-.664.053-.209.031.209.707-.109a1.8 1.8 0 0 1-.13-.852zM40.875 68.7a7.1 7.1 0 0 1-3.131 2.485l.492 2.435 3.49-.7a9.007 9.007 0 0 1-.851-4.22zm-21.322-1.194a.553.553 0 0 0-.17-.079l.092.193zm-14-10.542L0 58.783l20.981 18.283.727-.238zm14.295 3.582a.773.773 0 0 1 .6.286c.276.336.269.792.031 2.074l5.072 11.376h.749l-6.356-29-5.607 3.845 5.134 11.516a.8.8 0 0 1 .372-.097zm17.845-16.688l-4.732 2.137-1.655 10.772 2.469 2.6zm8.9 15.923l-4.628-1.468-11.326 17.375.356 1.71 5.884-6.647-.007-.034.054-.018zM33.012 68.7l4.732-9.587-1.669.26zm-21.2-11.772l-.407 1.043 4.325 4.865zm14.442 1.957l.774-7.048-.981.541z",
    transform: "translate(5.03 10.738) translate(0 -43.858)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplosive);
export default __webpack_public_path__ + "static/media/explosive.60c9cc4958952b638d5f59aff73ab2a1.svg";
export { ForwardRef as ReactComponent };